import { useEffect } from 'react';
import { TimePeriodPicker } from '@/components/TimePeriodPicker';
import { selectorStates } from '@/config/globalVars';
import { useStoriesContext } from '@/views/story/buildStory/StoriesContext';
import { TimePeriod } from '@/types/ReportRun';

export const StoryTimePeriodSelector = () => {
    const {
        setDataSpecificationValues,
        dataSpecificationValues,
        updatePanelStatus,
        getSelectorConfiguration,
    } = useStoriesContext();
    let { selectorConfiguration, selectorIndex } = getSelectorConfiguration('time_period');
    
    // SKU 984 (Performance Snapshot) has a fixed time period of 'Latest Year' for relative kind of time period and 52 weeks for custom kind of time period as per BYZ-18186
    const isPerformanceSnapshot = dataSpecificationValues.sku === '984';

    const handleTimePeriodChange = (e: ByzzerChangeEvent<TimePeriod>) => {
        const value = e.value;
        let nextTimePeriod: TimePeriod;

        if (!isPerformanceSnapshot) {
            nextTimePeriod = value;
        } else if (value.type === 'relative') {
            nextTimePeriod = { ...value, period: 'Latest Year' };
        } else {
            nextTimePeriod = {
                ...value,
                period: {
                    ...(typeof value.period === 'object' && value.period ? value.period : {}),
                    weeks: 52,
                },
            } as TimePeriod;
        }

        setDataSpecificationValues({
            ...dataSpecificationValues,
            runConfig: { ...dataSpecificationValues.runConfig, timePeriod: nextTimePeriod },
        });
    };
    //TODO : THIS CODE WILL BE MOVED TO storiesContext FILE
    useEffect(() => {
        let timePeriod = dataSpecificationValues.runConfig.timePeriod;

        if (timePeriod.type === 'relative' || timePeriod.type === 'cps_relative') {
            if (timePeriod.period) {
                updatePanelStatus(selectorIndex, selectorStates.completed);
            } else {
                updatePanelStatus(selectorIndex, selectorStates.pending);
            }
        } else {
            if (timePeriod.type === 'cps_custom') {
                if (timePeriod?.period?.endDate && timePeriod.period?.months) {
                    updatePanelStatus(selectorIndex, selectorStates.completed);
                } else {
                    updatePanelStatus(selectorIndex, selectorStates.pending);
                }
            } else {
                //@ts-ignore
                if (timePeriod.period && timePeriod.period.endDate && timePeriod.period.weeks) {
                    updatePanelStatus(selectorIndex, selectorStates.completed);
                } else {
                    updatePanelStatus(selectorIndex, selectorStates.pending);
                }
            }
        }
    }, [dataSpecificationValues.runConfig.timePeriod]);
    return (
        <>
            <TimePeriodPicker
                name={'timePeriod'}
                value={dataSpecificationValues.runConfig.timePeriod}
                onChange={handleTimePeriodChange}
                datatype={selectorConfiguration?.datatype}
                sku={dataSpecificationValues.sku}
                disabled={{ preset: isPerformanceSnapshot, weeks: isPerformanceSnapshot }}
                {...(isPerformanceSnapshot && { timePeriodOptions: ['Latest Year'] })}
            />
        </>
    );
};
